var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.loading ? _c('div', {
    staticClass: "coupon"
  }, [_vm.coupon ? [_c('div', {
    staticClass: "coupon--header"
  }, [_vm.coupon.name ? _c('div', {
    staticClass: "s-px-3 s-text-2xl s-font-bold text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.coupon.name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "s-mt-2"
  }, [_vm._v(" 使用期限："), _c('time', [_vm._v(" " + _vm._s(_vm.startToEnd))])])]), _c('div', {
    staticClass: "coupon--wrapper"
  }, [_c('div', {
    staticClass: "coupon--branch"
  }, [_vm._v(" " + _vm._s(_vm.boundBranchText) + " ")]), _c('div', {
    staticClass: "coupon--image"
  }, [_vm.coupon && _vm.coupon.img_url ? _c('img', {
    attrs: {
      "src": _vm.coupon.img_url
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "coupon--body"
  }), _c('div', {
    staticClass: "coupon--footer"
  }, [_c('div', {
    staticClass: "coupon--line mb-2"
  }), _vm.showConfirmButton ? _c('div', {
    staticClass: "s-mb-4 s-mt-3"
  }, [_c('div', {
    staticClass: "coupon-confirm mb-1"
  }, [_vm._v("確認使用後將無法復原，請您確認。")]), _c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.coupon.used_date || _vm.isExpired
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmButtonText) + " ")])]) : _vm._e(), _vm.coupon && _vm.coupon.description ? _c('div', {
    staticClass: "s-mb-4 s-px-3 coupon--desc",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.coupon.description)
    }
  }) : _vm._e(), _vm.getModuleConfig('coupon_detail_page.cancel_button_text') ? _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('coupon_detail_page.cancel_button_text'),
      "button-url": _vm.getModuleConfig('coupon_detail_page.cancel_button_url'),
      "type": _vm.getModuleConfig('coupon_detail_page.cancel_button_action')
    }
  }) : _vm._e()], 1)])] : [_c('div', {
    staticClass: "coupon--header"
  }, [_c('div', {
    staticClass: "s-px-3 s-text-2xl s-font-bold text-truncate"
  }, [_vm._v(" 此優惠券不存在 ")]), _vm.errorMessage ? _c('div', [_c('p', {
    staticClass: "s-mt-2"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()])]], 2) : _c('div', [_c('b-spinner', {
    attrs: {
      "variant": "secondary"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }